import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import perfType from './prop-types';
import { month2Label } from './utils';
import { sinceYears, formatPercent } from '../shared-utils';

/* eslint-disable no-nested-ternary */
const Container = styled.div`
  display: flex;
  flex-direction: ${props => (props.theme.isMobileOrTablet ? 'column' : 'row')};

  & > div {
    min-width: ${props => (props.theme.isMobile ? '100%' : (props.theme.isXLarge ? '204px' : '126px'))};
    display: flex;
    flex-direction: column;
    margin-bottom: ${props => (props.theme.isMobile ? 40 : 36)}px;

    > .period {
      font: ${props => props.theme.fontWeightBold} 14px/16px ${props => props.theme.fontFamilyBody};
      color: ${props => props.theme.secondaryColor};
      letter-spacing: 0.1px;
      text-transform: uppercase;
    }

    > .return {
      > * {
        font: ${props => props.theme.fontWeightBold} 32px/100% ${props => props.theme.fontFamilyBody};
        color: ${props => props.theme.bodyColor};
        letter-spacing: 0.1px;
      }

      > .small {
        margin-left: 4px;
        font-weight: ${props => props.theme.fontWeightBold};
        font-size: 19px;
      }

      > .date {
        margin-left: 2px;
        font-size: 19px;
        font-weight: ${props => props.theme.fontWeightRegular};
      }
    }
  }

  ${props => props.theme.isMobile && `
    & > div:last-child {
      margin-bottom: 0;
    }
  `};
`;
/* eslint-enable no-nested-ternary */

const Return = ({ val, month, since }) => {
  if (Number.isNaN(val)) {
    return null;
  }

  return (
    <div>
      <span className="period">{month2Label(month)}</span>
      <div className="return">
        <span className="return-value">{formatPercent(val)}</span>
        {!Number.isFinite(month) && (
          <>
            <span className="small">p.a.</span>
            <span className="date">{sinceYears(since)}</span>
          </>
        )}
      </div>
    </div>
  );
};

Return.propTypes = {
  val: PropTypes.number,
  month: PropTypes.number.isRequired,
  since: PropTypes.string.isRequired,
};

Return.defaultProps = { val: Number.NaN };

const value4Month = (list, months) => _.get(_.find(list, { months }), 'value');

export default function Highlights({ perf, attrs, since }) {
  return (
    <Container>
      {attrs.map(d => <Return key={d} val={value4Month(perf, d)} month={d} since={since} />)}
    </Container>
  );
}

Highlights.propTypes = {
  perf: perfType.isRequired,
  attrs: PropTypes.arrayOf(PropTypes.number).isRequired,
  since: PropTypes.string.isRequired,
};
